import registrationAndResetTemplate from "./registrationAndResetTemplate";

const registrationWithoutPinTemplate = `
<form name="registerForm" ng-submit="registerWithoutPin('registration')" autocomplete="off" novalidate>
    ${registrationAndResetTemplate}
</form>
`;
export default registrationWithoutPinTemplate;